define(function(require) {
    const Backbone = require('backbone');
    const BaseView = require('app/Base.view');
    const ButtonToggleGroup = require('components/ButtonToggleGroup.view');
    const ButtonView = require('components/Button');
    const _ = require('underscore');
    const CC = require('CC');
    const dragula = require('vendor/dragula');
    require('vendor/dragula.css');
    require('./DataGridColumns.css');

    const DataGridColumnsView = BaseView.extend({
        template: _.template(/*template*/ `       
            <div class="data-grid-columns">
                <div class="data-grid-columns__list"></div>
                <hr/>
                <div class="data-grid-columns__reset-sort"></div>
            </div>
        `),

        defaults: function() {
            return {
                clientId: CC.utils.getCurrentClientId(),
                state: undefined,
                startOffset: 1
            };
        },

        events: {},

        validation: [
            {
                name: 'columns',
                required: true
            },
            {
                name: 'collection',
                required: true
            }
        ],

        initialize: function(options) {
            this.validateProperties();

            // Listen for state updates. In theory, the state api would
            // be better but it's always null in here?
            this.listenTo(this.collection, 'DataGrid:StateLoaded', data => {
                this.state = data;
                this.render();
            });
        },

        render: function() {
            const viewOptions = {};
            const state = this.state;

            const allColumns = this.columns.map(column => {
                return _.extend(column, {
                    id: column.name,
                    name: column.title
                });
            });
            let columns = [];
            if (state && state.colReorder) {
                for (const col of state.colReorder) {
                    if (allColumns[col]) {
                        columns.push(allColumns[col]);
                    }
                }
            } else {
                columns = allColumns;
            }

            // Filter out the columns that don't have a name (eg. Actions, Select)
            const buttonOptions = new Backbone.Collection(
                columns
                    .filter(column => column.name && !column.exportOnly)
                    .map(nextColumn => {
                        if (nextColumn.title == 'Actions') {
                            nextColumn.optional = false;
                        }
                        return nextColumn;
                    })
            );

            this.$el.html(this.template(viewOptions));
            this.createAndRenderSubView('.data-grid-columns__list', ButtonToggleGroup, {
                toggleType: 'checkbox',
                layoutClass: 'flex-column',
                buttonClass: 'data-grid-columns__column drag-handle',
                buttonOptions: buttonOptions,
                checkedClass: 'lotacon lotacon-check-square',
                onChange: (id, option, isChecked, groupName, e) => {
                    if (option.get('name') == 'selectAll') {
                        return;
                    }

                    this.collection.trigger('DataGrid:Column::VisibilityChange', option.get('id'), isChecked);

                    e.stopPropagation();
                }
            });

            if (this.hasValue(this.collection.defaultSort) && this.collection.defaultSort.label) {
                // If a default sort is set, show a link to reset back to defaults
                this.createAndRenderSubView('.data-grid-columns__reset-sort', ButtonView, {
                    actions: [
                        {
                            name: 'reset-sort',
                            label: `Reset sort to ${this.collection.defaultSort.label}`
                        }
                    ],
                    buttonStyle: 'button--tertiary',
                    onChange: (e, actionModel) => {
                        this.collection.trigger('DataGrid:ResetSort');
                    }
                });
            }

            this.prepDragnDrop();

            return this;
        },

        prepDragnDrop: function() {
            const self = this;
            const containers = [];
            self.$('.toggleGroup').each(function() {
                containers.push(this);
            });
            let reorderStart = -1;

            // Handle drag and drop
            this.dragger = dragula({
                containers: containers,
                direction: 'vertical',
                // Releasing a drag outside of another element should be cancelled
                revertOnSpill: true,
                copy: false,
                moves: function(el, container, handle) {
                    return true;
                }
            })
                .on('drag', (el, source) => {
                    reorderStart = this.$('.data-grid-columns__column').index(el) + this.startOffset;
                })
                .on('drop', (el, target, source, sibling) => {
                    const reorderStop = this.$('.data-grid-columns__column').index(el) + this.startOffset;

                    // Build an array of indexes length of number of columns
                    const numCols = this.columns.length;
                    const newOrder = [];
                    for (let i = 0; i < numCols; i++) {
                        newOrder.push(i);
                    }

                    // Remove dragged index from array
                    newOrder.splice(reorderStart, 1);

                    //. Insert start index into array at stop index
                    newOrder.splice(reorderStop, 0, reorderStart);
                    this.collection.trigger('DataGrid:ReorderColumns', newOrder);
                });
        }
    });

    return DataGridColumnsView;
});
